(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tendenzo-reviews-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tendenzo-review-stories')) {
    customElements.define('tendenzo-review-stories', class extends HTMLElement {
      connectedCallback() { this.addEventListener('click', this.onClick); this.applyFilter('recent'); }
      disconnectedCallback() { this.removeEventListener('click', this.onClick); }
      onClick = (event) => { const button = event.target.closest('[data-filter]'); if (button) this.applyFilter(button.dataset.filter); };
      applyFilter(mode) {
        const list = this.querySelector('.tz-stories__list');
        if (!list) return;
        const cards = [...list.querySelectorAll('[data-review]')];
        const timestamp = (card) => Date.parse(card.dataset.date) || 0;
        cards.sort((a, b) => mode === 'helpful' ? Number(b.dataset.helpful) - Number(a.dataset.helpful) || Number(a.dataset.order) - Number(b.dataset.order) : timestamp(b) - timestamp(a) || Number(a.dataset.order) - Number(b.dataset.order));
        for (const card of cards) { card.hidden = mode === 'photo' && card.dataset.photo !== 'true'; list.append(card); }
        this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === mode)));
        this.querySelector('.tz-stories__empty').hidden = cards.some(card => !card.hidden);
        list.scrollTop = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tendenzo-three-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tendenzo-image-comparison')) {
    customElements.define('tendenzo-image-comparison', class extends HTMLElement {
      connectedCallback() { this.addEventListener('input', this.onInput); }
      disconnectedCallback() { this.removeEventListener('input', this.onInput); }
      onInput = (event) => { if (event.target.matches('input[type="range"]')) this.style.setProperty('--reveal', event.target.value + '%'); };
    });
  }

  } catch(e) { console.error(e); }
})();
})();
